/* global jQuery */
/* global tribe */
/* global Qs */

// prettier-ignore
const getElements = () => ({
    $container: jQuery('.tribe-events'),
    $filterBar: jQuery(tribe.filterBar.filterToggle.selectors.filterBar),
    filterBar: document.querySelector(tribe.filterBar.filterToggle.selectors.filterBar),
    filtersModalOpenButtonSelector: '.tribe-events-c-events-bar__custom-search-button',
    filtersModalOpenButton: document.querySelector('.tribe-events-c-events-bar__custom-search-button'),
    filterModalCloseButtonSelector: '.tribe-filter-bar__modal-header-close',
    filtersModalCloseButton: document.querySelector('.tribe-filter-bar__modal-header-close'),
    filtersModalShowResultsButtonSelector: '.tribe-filter-bar__show-results-button',
    filtersModalShowResultsButton: document.querySelector('.tribe-filter-bar__show-results-button')
});

let elements = getElements();

// Open filters modal
document.body.addEventListener('click', (e) => {
	if (
		e.target === elements.filtersModalOpenButton ||
		e.target.closest(elements.filtersModalOpenButtonSelector)
	) {
		e.stopPropagation();
		e.preventDefault();
		elements = getElements();
		tribe.filterBar.filterBarState.openFilterBar(elements.$container);
	}
});

// Close filters modal (close button)
document.body.addEventListener('click', (e) => {
	if (
		e.target === elements.filterModalCloseButton ||
		e.target.closest(elements.filterModalCloseButtonSelector)
	) {
		e.stopPropagation();
		e.preventDefault();
		elements = getElements();
		elements.filtersModalCloseButton.blur();
		tribe.filterBar.filterBarState.closeFilterBar(elements.$container);
	}
});

// Close filers modal (show results button)
document.body.addEventListener('click', (e) => {
	if (
		e.target === elements.filtersModalShowResultsButton ||
		e.target.closest(elements.filtersModalShowResultsButtonSelector)
	) {
		e.stopPropagation();
		e.preventDefault();
		elements = getElements();
		elements.filtersModalShowResultsButton.blur();
		tribe.filterBar.filterBarState.closeFilterBar(elements.$container);
	}
});

// Redefine existing TEC functions
tribe.filterBar.filterBarState.setup = function (container) {
	const obj = tribe.filterBar.filterBarState;
	const $container = jQuery(container);

	if (!$container.is(obj.selectors.container)) {
		return;
	}

	const $filterBar = $container.find(obj.selectors.filterBar);

	// Return early if mobile initial state control is false.
	if (!$filterBar.data('mobileInitialStateControl')) {
		return;
	}

	const $data = $container.find(obj.selectors.dataScript);
	let data = {};

	// If we have data element set it up.
	if ($data.length) {
		data = JSON.parse($data.text().trim());
	}

	const breakpoints = Object.keys(data.breakpoints);

	breakpoints.forEach(function (breakpoint) {
		if (
			'medium' === breakpoint &&
			$container.outerWidth() < data.breakpoints[breakpoint]
		) {
			obj.closeFilterBar($container);
		}
	});
};

elements.$container.on('afterSetup.tribeEvents', function () {
	// Redefine filterButton click handler to not close filter modal when clicking search bar
	tribe.filterBar.filterButton.handleClick = function (event) {
		const $container = event.data.container;
		const containerState = $container.data('tribeEventsState');
		const isMobile = containerState.isMobile;
		const obj = tribe.filterBar.filterButton;

		// Return early if not mobile.
		if (!isMobile) {
			return;
		}

		const $target = jQuery(event.target);
		const isParentFilterBar = Boolean(
			$target.closest(obj.selectors.filterBar).length
		);
		const isParentFilterButton = Boolean(
			$target.closest(obj.selectors.filterButton).length
		);
		const isParentSelect2ChoiceRemove = Boolean(
			$target.closest(obj.selectors.select2ChoiceRemove).length
		);
		const isModalSearchBar = Boolean(
			$target.closest(
				tribe.events.views.eventsBar.selectors.searchContainer
			).length
		);

		if (
			!isParentFilterBar &&
			!isParentFilterButton &&
			!isParentSelect2ChoiceRemove &&
			!isModalSearchBar
		) {
			tribe.filterBar.filterBarState.closeFilterBar($container);
		}
	};

	// Redefine search submit handler to not close filter modal on submit
	tribe.events.views.manager.onSubmit = function (event) {
		const obj = tribe.events.views.manager;
		const $container = tribe.events.views.manager.getContainer(this);
		$container.trigger('beforeOnSubmit.tribeEvents', event);

		event.preventDefault();

		// The submit event is triggered on the form, not the container.
		const $form = jQuery(this);

		const formData = Qs.parse($form.serialize());

		const data = {
			view_data: formData['tribe-events-views'],
		};

		// Pass the data to the request reading it from `tribe-events-views`.
		obj.request(data, $container);

		$container.trigger('afterOnSubmit.tribeEvents', event);

		return false;
	};

	// tribe.events.views.filterBar.handleAfterOnSubmit = function (
	// 	event,
	// 	onSubmitEvent
	// ) {
	// 	console.log('tribe.events.views.filterBar.handleAfterOnSubmit');

	// 	const obj = tribe.events.views.filterBar;
	// 	const $form = jQuery(onSubmitEvent.target);

	// 	// only run if form is search form
	// 	if (!$form.is(obj.selectors.searchForm)) {
	// 		return;
	// 	}

	// 	const $container = jQuery(event.target);
	// 	const $filtersForm = $container.find(obj.selectors.filtersForm);

	// 	jQuery.fn.reverse = Array.prototype.reverse;

	// 	$form
	// 		.find(obj.selectors.filterItem)
	// 		.reverse()
	// 		.each(function (filterItemIndex, filter) {
	// 			const $filter = jQuery(filter);

	// 			// adjust field name back to original
	// 			$filter.find('[name]').each(function (index, field) {
	// 				const $field = jQuery(field);
	// 				const name = $field.attr('name');
	// 				let adjustedName;

	// 				if (name.slice(-2) === '[]') {
	// 					adjustedName = name.slice(19, name.length - 3) + '[]';
	// 				} else {
	// 					adjustedName = name.slice(19, name.length - 1);
	// 				}

	// 				$field.attr('name', adjustedName);
	// 			});

	// 			// move filter back to filters form
	// 			$filter
	// 				.removeClass(obj.selectors.visualHide.className())
	// 				.prependTo($filtersForm);
	// 		});

	// 	delete jQuery.fn.reverse;
	// };
});
